import React from 'react'

import PropTypes from 'prop-types'

import './testimonial17.css'

const Testimonial17 = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="testimonial17-max-width thq-section-max-width">
        <div className="testimonial17-container">
          <h2 className="thq-heading-2">{props.heading1}</h2>
          <span className="testimonial17-text1 thq-body-small">
            {props.content1}
          </span>
        </div>
        <div className="thq-grid-2">
          <div className="testimonial17-accent2-bg thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div data-animated="true" className="thq-card testimonial17-card">
                <div className="testimonial17-container2">
                  <img
                    alt={props.author1Alt}
                    src="https://images.unsplash.com/photo-1521119989659-a83eee488004?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDM3fHxwZXJzb258ZW58MHx8fHwxNzIwMjgxNTU1fDA&amp;ixlib=rb-4.0.3&amp;w=200"
                    className="testimonial17-image"
                  />
                  <div className="testimonial17-container3">
                    <strong className="thq-body-large">
                      {props.author1Name}
                    </strong>
                    <span className="thq-body-small">
                      {props.author1Position}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text4 thq-body-small">
                  {props.review1}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="testimonial17-accent1-bg1 thq-animated-card-bg-1"></div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="testimonial17-accent1-bg2 thq-animated-card-bg-1"></div>
          </div>
          <div className="testimonial17-accent2-bg3 thq-animated-card-bg-2">
            <div className="testimonial17-accent1-bg3 thq-animated-card-bg-1"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

Testimonial17.defaultProps = {
  author2Alt: 'Image of Jane Smith',
  author1Alt: 'Image of John Doe',
  content1: 'Přečtěte si, co o numerologických službách říkají naši klienti.',
  author3Name: 'David Johnson',
  author3Position: 'Entrepreneur',
  author1Position: 'Projektový manažer',
  review4:
    'I never thought numerology could be so insightful until I tried this service. It exceeded my expectations.',
  author3Alt: 'Image of David Johnson',
  heading1: 'Co doporučují zákazníci',
  author3Src:
    'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1080',
  author2Name: 'Jane Smith',
  review1:
    'Numerologie má něco do sebe. Všímám si určitých charakterních znaků, se kterými se mi díky takto získanému obrazu lépe pracuje.',
  author2Position: 'Co doporučují',
  review3:
    'The numerology report I received was spot on! It helped me make important decisions with confidence.',
  author1Src:
    'https://images.unsplash.com/photo-1508905475152-c325323ac955?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1080',
  author1Name: 'Martin Man',
  author4Src:
    'https://images.unsplash.com/photo-1460904577954-8fadb262612c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1080',
  author4Name: 'Sarah Brown',
  author4Position: 'Teacher',
  author4Alt: 'Image of Sarah Brown',
  review2:
    'I highly recommend this numerology service to anyone looking for guidance and clarity. It was a truly eye-opening experience.',
  author2Src:
    'https://images.unsplash.com/photo-1529675804080-e12a8d5cef9b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1080',
}

Testimonial17.propTypes = {
  author2Alt: PropTypes.string,
  author1Alt: PropTypes.string,
  content1: PropTypes.string,
  author3Name: PropTypes.string,
  author3Position: PropTypes.string,
  author1Position: PropTypes.string,
  review4: PropTypes.string,
  author3Alt: PropTypes.string,
  heading1: PropTypes.string,
  author3Src: PropTypes.string,
  author2Name: PropTypes.string,
  review1: PropTypes.string,
  author2Position: PropTypes.string,
  review3: PropTypes.string,
  author1Src: PropTypes.string,
  author1Name: PropTypes.string,
  author4Src: PropTypes.string,
  author4Name: PropTypes.string,
  author4Position: PropTypes.string,
  author4Alt: PropTypes.string,
  review2: PropTypes.string,
  author2Src: PropTypes.string,
}

export default Testimonial17
